import {createAsyncThunk} from '@reduxjs/toolkit';
import axios from "axios";
import {getCookie, setCookie} from "../../utils/cookie";
import logoutAndRedirect from "../../utils/logoutAndRedirect";
import { getAccessToken } from "../../utils/tokenStore";

const URL_API = process.env.URL_API;

export interface ResetResult {
    data: any[];
}

export const retrieveMyBusinessProfile = createAsyncThunk(

    'business_profile/retrieve',
    async (supplierID: any, { rejectWithValue }) => {

        const { id }  = getCookie('auth')
        const api_url = `${URL_API}/supplier-portal/details`;

        try {
            const { data } = await axios.get<ResetResult>(api_url,  {
                headers: {
                    'Authorization': `Bearer ${getAccessToken()}`
                }
            });

            return data;
        } catch (error) {

            // @ts-ignore
            if(error.response.status === 401){
                logoutAndRedirect('/sign-in')
            }

            // @ts-ignore
            return rejectWithValue(error.response.data)
        }
    }
);